import GameModel from "../../../core/src/model/GameModel";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import ConsoleUtil from "../../../core/src/utils/ConsoleUtil";
import Utils from "../../../core/src/utils/Utils";

export default class GetUserRequest implements IRequestBuilder {
    get requestData(): any {
        let userId = GameModel.urlParams.userId || undefined;

        ConsoleUtil.green("Login with userId: " + userId);

        return {
            action: "getUser",
            userId: userId,
            authToken: GameModel.authToken,
            currency: GameModel.currency,
            coins: GameModel.coinsAmount,
            casino: GameModel.casino,
            serverVersion: GameModel.apiConfig.serverVersion,
            gameVersion: Utils.isNullOrWhiteSpace(GameModel.apiConfig.gameVersion) ? GameModel?.gameVersion : GameModel.apiConfig.gameVersion,
            deviceInfo: Utils.getDeviceInfo(),
        };
    }

    get method(): string {
        return "POST";
    }
    get path() {
        let domain =
            GameModel.apiConfig.domain ||
            window.location.protocol + "//" + window.location.hostname;
        let port = GameModel.apiConfig.port;
        let portString = port ? ":" + port : "";
        return domain + portString + "/session";
    }
}
